import { useOrgIdFromModel } from './useOrgIdFromModel';
import { useOrgIdFromBoard } from './useOrgIdFromBoard';
import { useOrgIdFromCard } from './useOrgIdFromCard';
import { getRouteIdFromPathname, routes } from '@trello/routes';
import { useState, useEffect } from 'react';

/** Determines the orgId (if any) for the current route */
export const useOrgIdFromRoute = (routePath: string) => {
  const routeId = getRouteIdFromPathname(routePath);
  const routeType = routes[routeId]?.routeType;
  const isOrg = routeType === 'memberOrOrg' || routeType === 'org';
  const isBoard = routeType === 'board';
  const isCard = routeType === 'card';
  // Org ID query arg based on route type
  const [modelName, setModelName] = useState('');
  const [boardId, setBoardId] = useState('');
  const [cardId, setCardId] = useState('');
  // Org ID based on route type
  const orgIdFromModel = useOrgIdFromModel(modelName);
  const orgIdFromBoard = useOrgIdFromBoard(boardId);
  const orgIdFromCard = useOrgIdFromCard(cardId);

  const resetQueryArgs = () => {
    setModelName('');
    setBoardId('');
    setCardId('');
  };

  useEffect(() => {
    resetQueryArgs();

    const splitRoute = routePath.split('/');
    if (isOrg) setModelName(splitRoute[1]);
    else if (isBoard) setBoardId(splitRoute[2]);
    else if (isCard) setCardId(splitRoute[2]);
  }, [routePath, isOrg, isBoard, isCard]);

  return isOrg
    ? orgIdFromModel
    : isBoard
    ? orgIdFromBoard
    : isCard
    ? orgIdFromCard
    : '';
};
